const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

export const getSentryConfig = () => {
  const sentryConfig = {
    dsn:
      SENTRY_DSN ||
      'https://0741cd9acbd146d29d324ff70885efe5@o1012220.ingest.sentry.io/4504955279900672',
    tracesSampleRate: 0.2,
    enabled: process.env.NODE_ENV === 'production',
    environment: process.env.APP_STAGE,
  };

  return sentryConfig;
};
